import { render, staticRenderFns } from "./ConceptosDeSalarios.vue?vue&type=template&id=e53ad900"
import script from "./ConceptosDeSalarios.vue?vue&type=script&lang=js"
export * from "./ConceptosDeSalarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports